/**
 * Data-driven UI application logic that pertains to Backbone collections
 *
 * Created by ipatrikeeva on 06/02/2017
 */

/**
 * Read a JSON model and return a Backbone.Collection
 * @param jsonModel {[object]} - an array of objects
 * @return {BackboneCollection}
 */
function getBackboneCollection(jsonModel) {

    var collection = new BackboneCollection();
    // Load new Backbone.Collection with JSON models
    collection.reset(jsonModel);
    return collection;
}

/**
 * Convert a JSON UI model into a Backbone.Collection object
 * @param model {object} - JSON UI model
 * @returns {BackboneCollection}
 */
function getBackboneCollectionFromUIModel( model ) {

    var recordCollection,
        modelArray,
        modelObject;

    if ( model ) {
        modelArray = model.properties;
        if ( modelArray && modelArray.length === 1 ) {
            modelObject = modelArray[ 0 ];

            if ( modelObject ) {
                recordCollection = getBackboneCollection( modelObject.properties );
            }
        }
    }

    return recordCollection;
}

/**
 * Return a Backbone.Collection from a ES record._source object
 * @param record {object} - ES record
 * @returns {BackboneCollection}
 */
function getBackboneCollectionFromSource( record ) {

    var recordModels,
        recordCollection;

    if ( record ) {
        recordModels = getBackboneRecordModels( record._source );
        recordCollection = new BackboneCollection;
        recordCollection.reset( recordModels );
    }

    return recordCollection;
}

/**
 * Backbone Collection view for an empty collection of items
 */
var EmptyCollectionView = Backbone.Marionette.ItemView.extend({
    template: '#empty-panel-template'
});

/**
 * Get a region layout collection for a nested object
 * @param dataObject {Object} - data object containing field labels, field labels and field types
 * @returns {Backbone.Marionette.CompositeView}
 */
function getNestedLayoutCollection(dataObject) {
    var layoutModel,
        layoutCollection = new BackboneCollection(),
        key;

    for (key in dataObject) {
        if (dataObject.hasOwnProperty(key)) {
            layoutModel = new BackboneModel();
            layoutModel.set("field", key);
            layoutModel.set("label", dataObject[key].label);
            layoutModel.set("value", dataObject[key].value);
            layoutModel.set("type", dataObject[key].type);

            if ( dataObject[key].multiple && dataObject[key].multiple.toString() === "true") {
                layoutModel.set("multiple", "true");
            }
            if ( dataObject[key].expanded && dataObject[key].expanded.toString() === "true") {
                layoutModel.set("expanded", "true");
            }
            if ( dataObject[key].is_link && dataObject[key].is_link.toString() === "true") {
                layoutModel.set("is_link", "true");
            }
            if ( dataObject[key].is_searchable && dataObject[key].is_searchable.toString() === "true") {
                layoutModel.set("is_searchable", "true");
            }
            if ( dataObject[key].has_viewer ) {
                layoutModel.set("has_viewer", dataObject[key].has_viewer );
            }
            layoutCollection.add(layoutModel);
        }
    }


    return layoutCollection;
}

/**
 * Get a region layout collection for an array of objects
 * @param model {Object} - region view model JavaScript object
 * @param dataObject {Object} - data object containing field labels, field labels and field types
 * @returns {Backbone.Marionette.CompositeView}
 */
function getMultipleLayoutCollection(model, dataObject) {
    var layoutCollection = new BackboneCollection(),
        fields = model.fields,
        fieldNames,
        object,
        valueArray,
        fieldName,
        fieldObject,
        fieldModel,
        valueType,
        i,
        j,
        k;

    for (j = 0; j < fields.length; j++) {
        fieldNames = fields[j].names;
        for (i = 0; i < dataObject.length; i++) {
            object = dataObject[i];
            valueArray = [];
            for (k = 0; k < fieldNames.length; k++) {
                fieldName = fieldNames[k];
                fieldObject = object[fieldName];
                if (hasKeys(fieldObject)) {
                    valueType = fieldObject.type || typeof fieldObject.value;
                    valueArray.push( { field: fieldName, value : fieldObject.value, type: valueType });
                } else {
                    valueArray.push( { field: "", value : "", type: null });
                }
            }
            fieldModel = new BackboneModel();
            fieldModel.set("values", valueArray);
            layoutCollection.add(fieldModel);
        }
    }
    return layoutCollection;
}

/**
 * Get a region layout collection for a nested object that contains an array of objects
 * @param model {Object} - region view model JavaScript object
 * @param dataObject {[Object]} - data object array containing objects with field names as keys, field labels, field types and field values as values
 * @returns {object} - Backbone.Marionette.CompositeView
 */
function getNestedMultipleLayoutCollection( model, dataObject ) {

    var fields = model.fields,
        layoutCollection = new BackboneCollection(),
        object = {},
        i,
        k,
        l,
        fieldNames,
        fieldObjects,
        item,
        itemName,
        itemLabel,
        itemValue,
        itemType,
        fieldModel,
        valueArray;

    // dataObject is a nested array of objects representing one nested object with multiple objects inside
    // Transform dataObject into a non-nested object with key for each field in the view model and an array of objects as key values
    for (i = 0; i < dataObject.length; i++) {
        if (fields.length === dataObject.length) {
            fieldNames = fields[i].names;
        }

        fieldObjects = dataObject[i]; // array of objects

        if ( model.default ) {
            // iterate over every object key
            valueArray = [];
            for ( var objectKey in fieldObjects ) {
                if ( fieldObjects.hasOwnProperty(objectKey) ) {
                    object = fieldObjects[ objectKey ];

                    if ( object ) {
                        itemLabel = object.label;
                        itemValue = object.value;
                        itemType = object.type;

                        valueArray.push( { field: objectKey, value: itemValue, label: itemLabel, type: itemType });
                    }
                }
            }

            fieldModel = new BackboneModel();
            fieldModel.set("values", valueArray);
            layoutCollection.add(fieldModel);

        } else {
            for (k = 0; k < fieldObjects.length; k++) {
                object = fieldObjects[k];
                if (object && fieldNames) {
                    valueArray = [];
                    for (l = 0; l < fieldNames.length; l++) {
                        itemName = fieldNames[l];
                        item = object[itemName];
                        if (item) {
                            itemValue = item.value;
                            itemType = item.type || typeof item.value;
                            valueArray.push( { field: itemName, value : itemValue, type: itemType, label: item.label } );
                        }
                    }
                    if (valueArray.length === fieldNames.length) {
                        fieldModel = new BackboneModel();
                        fieldModel.set("values", valueArray);
                        layoutCollection.add(fieldModel);
                    }
                }
            }
        }
    }

    return layoutCollection;
}


/**
 * Parse record Backbone collection into the display JavaScript object
 * @param dataCollection {BackboneCollection} - record Backbone collection
 * @param layoutModel {object} - region view model
 * @param response {object} - ES response object
 * @param fieldNames {[string]} - array of field names to include in the display
 * @returns {{}}
 */
function parseDataCollection( dataCollection, layoutModel, response, fieldNames ) {

    var dataObject = {},
        sourceObject,
        isMultiple,
        isNested,
        fieldName,
        compoundName,
        dataObjectField,
        additionalFields,
        key,
        fieldModel,
        properties,
        type,
        collection,
        k;

    if ( layoutModel ) {
        if ( layoutModel.multiple && layoutModel.multiple === "true" ) {
            isMultiple = true;
        }
        if ( layoutModel.nested && layoutModel.nested === "true" ) {
            isNested = true;
        }
        additionalFields = layoutModel.additionalFields;

        if (isMultiple && isNested) {
            // Array of objects
            sourceObject = getDataField(response, "_source");

            if ( fieldNames && fieldNames.length > 0 ) {
                fieldName = fieldNames[0];
                if (fieldName && fieldName.indexOf(".") > -1) {
                    compoundName = fieldName.split(".");
                    if (compoundName && compoundName.length === 2) {
                        fieldName = compoundName[0];
                    }
                }
                dataObjectField = sourceObject[ fieldName ];
                dataObject = parseArrayOfObjects( fieldNames, dataObjectField, dataCollection, additionalFields );
            }
        } else {

            for ( k = 0; k < fieldNames.length; k++ ) {
                fieldName = fieldNames[ k ];
                sourceObject = getDataField( response, "_source" );

                // For field names that start with underscore live above the _source object, keep original response object to parse
                if ( fieldNames[ k ].startsWith( "_" ) ) {
                    sourceObject = response;
                }
                // For nested field names that have a period in the name, get the field object
                else if ( fieldNames[ k ].indexOf( "." ) > -1 ) {
                    compoundName = fieldNames[ k ].split(".");
                    if ( compoundName && compoundName.length === 2 ) {
                        sourceObject = getDataField( sourceObject, compoundName[ 0 ] );
                        fieldName = compoundName[ 1 ];
                        // Get nested collection of data models
                        dataCollection = getNestedDataModel( dataCollection, compoundName[ 0 ] );
                    }
                }

                for ( key in sourceObject ) {
                    if (sourceObject.hasOwnProperty(key)) {
                        // check that field exists in the JSON model
                        fieldModel = lookupFieldModel(dataCollection, key);
                        if (fieldModel) {
                            // Get the nested values into a Backbone collection from the properties of the field model
                            properties = fieldModel.get("properties");
                            dataObjectField = sourceObject[key];

                            if ( ( fieldNames[k] === key && properties ) ) {
                                // Get values from properties object
                                collection = getBackboneCollection(properties);
                                type = fieldModel.get("type");
                                if ( type === "object" ) {
                                    dataObject = parseNestedObject(dataObjectField, collection);
                                }
                            }
                            else {
                                // Display non-nested fields
                                if ( ( fieldName === "all" || fieldName === key ) && dataObjectField !== null && fieldModel.get("type") && fieldModel.get("type") !== "object" ) {
                                    if (compoundName) {
                                        key = fieldNames[k];
                                    }
                                    dataObject = parseSimpleObject(dataObject, dataObjectField, fieldModel, key);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    return dataObject;
}

/**
 * Convert a JSON data model properties object into a Backbone collection
 * @param model {object} - JSON data model
 * @returns {BackboneCollection}
 */
function convertDataModelPropertiesToCollection( model ) {
    var dataCollection,
        modelProperties,
        modelPropertiesObject,
        propertiesObject,
        topCollection,
        typeModel,
        i;

    if ( model ) {
        modelProperties = model.properties;
        if ( modelProperties && modelProperties.length === 1 ) {
            modelPropertiesObject = modelProperties[ 0 ];

            if ( modelPropertiesObject ) {
                propertiesObject = modelPropertiesObject.properties;
                if ( propertiesObject ) {
                    dataCollection = getBackboneCollection( propertiesObject );
                }
                // TODO: remove type once edi_type is added to ES
                typeModel = new BackboneModel;
                typeModel.set("name", "_type");
                typeModel.set("label", "Type");
                typeModel.set("type", "string");
                dataCollection.add( typeModel );

            }
        }
    }

    topCollection = convertDataModelToCollection( model );
    if ( topCollection && topCollection.models ) {
        // Add top-level properties
        for ( i = 0; i < topCollection.models.length; i++ ) {
            dataCollection.add( topCollection.models[ i ] );
        }
    }
    return dataCollection;
}

/**
 * Convert top-level object keys into a Backbone collection
 * @param model {object} - JavaScript object
 * @returns {BackboneCollection}
 */
function convertDataModelToCollection( model ) {

    var topLevelCollection,
        modelProperties,
        modelPropertiesObject,
        key,
        propObject,
        propsArray = [];

    if ( model ) {
        // Add top-level properties as models
        modelProperties = model.properties;
        if ( modelProperties && modelProperties.length === 1 ) {
            modelPropertiesObject = modelProperties[0];
            propsArray = [];

            for ( key in modelPropertiesObject ) {
                if ( modelPropertiesObject.hasOwnProperty( key )) {

                   propObject = {};
                   propObject[ key ] = modelPropertiesObject[ key ];
                   propsArray.push( propObject );
                }
            }
        }
    }
    topLevelCollection = getBackboneCollection( propsArray );

    return topLevelCollection;

}
